import { BUILD_INFO, type BuildInfo } from '../buildInfo'

type StoreLike = {
  dispatch: (...args: unknown[]) => unknown
  getState: () => unknown
}

type PersistorLike = {
  flush?: () => Promise<unknown>
  purge?: () => Promise<unknown>
}

export interface SetupClientDevtoolsOptions {
  enabled?: boolean
  firebase: unknown
  persistor: PersistorLike
  store: StoreLike
}

export interface ClientDevtoolsBridge {
  appVersion: string
  buildInfo: BuildInfo
  deploymentEnv: string
  firebase: unknown
  persistor: PersistorLike
  store: StoreLike
  dispatch: StoreLike['dispatch']
  getState: StoreLike['getState']
}

const getBridgeTarget = () =>
  window as Window & {
    __JUSTLOCKIT_DEVTOOLS__?: ClientDevtoolsBridge
  }

const getDeploymentEnv = () =>
  (
    globalThis as typeof globalThis & {
      __DEPLOYMENT_ENV__?: string
    }
  ).__DEPLOYMENT_ENV__ ?? 'development'

export const setupClientDevtools = ({
  enabled = import.meta.env.DEV,
  firebase,
  persistor,
  store,
}: SetupClientDevtoolsOptions) => {
  if (!enabled) {
    return
  }

  const bridge: ClientDevtoolsBridge = {
    appVersion: __APP_VERSION__,
    buildInfo: BUILD_INFO,
    deploymentEnv: getDeploymentEnv(),
    firebase,
    persistor,
    store,
    dispatch: store.dispatch.bind(store),
    getState: store.getState.bind(store),
  }

  getBridgeTarget().__JUSTLOCKIT_DEVTOOLS__ = bridge
}
